// eslint-disable-next-line no-script-url
const DANGEROUS_PROTOCOLS = ["javascript:", "data:", "vbscript:", "blob:"];

const DEFAULT_ALLOWED_REDIRECT_HOSTS = "network-auth.com";

const allowedRedirectHosts = (
  process.env.REACT_APP_ALLOWED_REDIRECT_HOSTS || DEFAULT_ALLOWED_REDIRECT_HOSTS
)
  .split(",")
  .map((host) => host.trim().toLowerCase())
  .filter(Boolean);

const isAllowedRedirectHost = (hostname: string): boolean => {
  const host = hostname.toLowerCase();
  return allowedRedirectHosts.some(
    (allowedHost) => host === allowedHost || host.endsWith(`.${allowedHost}`)
  );
};

export const getSafeRedirectUrl = (url: string | null): string | null => {
  if (!url) return null;

  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch (_e) {
    return null;
  }

  if (parsed.protocol !== "https:" && parsed.protocol !== "http:") {
    return null;
  }

  if (!isAllowedRedirectHost(parsed.hostname)) {
    return null;
  }

  if (parsed.protocol === "https:") {
    return url;
  }

  parsed.protocol = "https:";
  return parsed.href;
};

export const hasDangerousProtocol = (url: string): boolean => {
  try {
    const parsed = new URL(url);
    return DANGEROUS_PROTOCOLS.includes(parsed.protocol);
  } catch (_e) {
    return false;
  }
};
